import moment from 'moment';
import Popup from 'popup/Popup';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { dispensingModuleManager, moduleManager } from 'redux/action/modules';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import { getYMDFormatDate } from 'utils/getCustomFormatDate';
import { nvl } from 'utils/nvl';
import EditableForm from './EditableForm';
import { ModuleEditable, ModuleEditablePopupContainer } from './ModuleEditablePopup.css.js';

const ModuleEditablePopup = ({ module, dataReloadFunc, children }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((store) => store.loginManager.status);
  const moduleGroups = useSelector((store) => store.moduleGroups.groups);
  const [popupOpen, setPopupOpen] = useState(null);
  const [moduleType, setModuleType] = useState(module.moduleType);
  const [xAxis, setxAxis] = useState(module.xAxis);
  const [yAxis, setyAxis] = useState(module.yAxis);

  useEffect(() => {
    setxAxis(module.xAxis);
    setyAxis(module.yAxis);
  }, [module]);

  const confirmModule = (data) => {
    const [url, moduleIdx, moduleStatus] =
      module.moduleIdx === undefined ? ['/api/module/insertData', null, 'blue'] : ['/api/module/updateData', module.moduleIdx, module.moduleStatus];

    customAxiosPostFunction(history, url, {
      ...data,
      authIdx: Number(data.authIdx),
      moduleIdx: moduleIdx,
      moduleStatus: moduleStatus,
      moduleGroupIdx: 1,
      deadline: nvl(data.deadline, '') === '' ? null : getYMDFormatDate(new Date(data.deadline)),
      xAxis: xAxis,
      yAxis: yAxis,
      rgstId: user.currentUser,
      rgstDt: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
    })
      .then((response) => {
        if (response !== null && response === 'success') {
          dispatch(dispensingModuleManager(Number(user.authIdx)));
          dispatch(moduleManager(Number(user.authIdx)));
          alert('등록완료');
          window.location.reload(false);
        } else if (response === 'duplicate') {
          alert('이미 등록된 장치번호 혹은 장치명입니다');
        } else {
          alert('등록실패');
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // 맵에서 새로운 위치를 클릭 시
  const selectNewArea = useCallback(
    (e) => {
      if (moduleType === 'DT') {
        return false;
      }

      setxAxis(e.nativeEvent.offsetX * 2);
      setyAxis(e.nativeEvent.offsetY * 2);
    },
    [moduleType]
  );

  if (!module || !moduleGroups) {
    return false;
  }

  return (
    <Popup
      trigger={children}
      modal
      open={popupOpen}
      onOpen={() => {
        setPopupOpen(true);
      }}
    >
      <ModuleEditablePopupContainer>
        <ModuleEditable>
          <EditableForm
            module={module}
            moduleGroups={moduleGroups}
            moduleType={moduleType}
            setModuleType={setModuleType}
            confirmModule={confirmModule}
            user={user}
          />
        </ModuleEditable>
      </ModuleEditablePopupContainer>
    </Popup>
  );
};

export default ModuleEditablePopup;
